import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=7cbbd136&scoped=true&"
import script from "./pc.vue?vue&type=script&lang=js&"
export * from "./pc.vue?vue&type=script&lang=js&"
import style0 from "./pc.vue?vue&type=style&index=0&id=7cbbd136&prod&lang=less&"
import style1 from "./pc.vue?vue&type=style&index=1&id=7cbbd136&prod&lang=less&scoped=true&"
import style2 from "./pc.vue?vue&type=style&index=2&id=7cbbd136&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbbd136",
  null
  
)

export default component.exports